import * as types from './types';
import { initialState } from './state';
import { actions } from './actions';
import { reducer } from './reducer';
import { postList as postMessage } from './postMessageObj';

export { types, initialState, actions, reducer, postMessage };
